import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, delay, ease }}
  >
    {children}
  </motion.div>
);

const lineV = { hidden: { y: "105%" }, show: (i) => ({ y: "0%", transition: { duration: 1.1, delay: i, ease } }) };

export const MaskLines = ({ lines, className = "", lineClass = "", delay = 0, animateNow = false }) => (
  <motion.span
    className={`block ${className}`}
    initial="hidden"
    {...(animateNow ? { animate: "show" } : { whileInView: "show", viewport: { once: true, amount: 0.1 } })}
  >
    {lines.map((l, i) => (
      <span key={l + i} className="block overflow-hidden pb-[0.08em]">
        <motion.span className={`block ${lineClass}`} variants={lineV} custom={delay + i * 0.12}>
          {l}
        </motion.span>
      </span>
    ))}
  </motion.span>
);

export const SectionLabel = ({ index, children }) => (
  <div className="flex items-center gap-4 font-mono text-xs uppercase tracking-[0.3em] text-[#D4AF37]">
    {index && <span className="text-[#E6C594]/80">{index}</span>}
    <span className="h-px w-10 bg-[#D4AF37]/50" />
    <span>{children}</span>
  </div>
);
